export default __webpack_public_path__ + "static/media/control-2-white.34802679.svg";